import { DevView } from "./DevView";
import { GameClient } from "./GameClient";

export function App() {
  const isDev = new URLSearchParams(window.location.search).has("dev");
  return isDev ? <DevView /> : <GameClient />;
}
